import { render, staticRenderFns } from "./StoreTab.vue?vue&type=template&id=1c591ad9"
import script from "./StoreTab.vue?vue&type=script&lang=js"
export * from "./StoreTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports